import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Application} from '../../applications/application/application';
import {ConfigService} from '../../config.service';
import {ApplicationEvent} from '../../applications/application/application.event';
import {ApplicationsService} from '../../applications/applications.service';
import {Meta, Title} from '@angular/platform-browser';
import * as _ from "lodash";
import {GoogleAnalyticsService} from 'ngx-google-analytics';
import { DisbursementExclusions } from 'src/app/applications/application/disbursement.exclusions';
import { DisbursementExclusionsService } from 'src/app/applications/disbursement.service';
import { CoreComponent } from 'src/app/core/core.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Results } from 'src/app/core/results';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-track-application',
  templateUrl: './track-application.component.html',
  styleUrls: ['./track-application.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TrackApplicationComponent extends CoreComponent<Application> {
  @Input() status: string;
  @Input() application: Application = new Application();
  @Output() withdrawApplication = new EventEmitter<Application>();
  @Input() applicationEvents = new Array<ApplicationEvent>();
  
  @Input() disbursementExclusions: Results<DisbursementExclusions> = new Results<DisbursementExclusions>()
  constructor(protected disbursementExclusionsService: DisbursementExclusionsService, public route: ActivatedRoute,private modalService: NgbModal,
                public activeModal: NgbActiveModal,protected gaService: GoogleAnalyticsService, public configService: ConfigService,
                public meta: Meta, public title: Title, private applicationsService: ApplicationsService, private matSnackBar: MatSnackBar, private router: Router) {
      super(disbursementExclusionsService,route);
      this.title.setTitle('Track Application');
    }

  ngOnInit() {    
    this.blockUI.start();
    this.disbursementExclusionsService.getDisbursementExclusions(this.application).subscribe((results: Results<DisbursementExclusions>) => {
      this.disbursementExclusions = results;
    });
    
    this.blockUI.stop();
  }

  close() {
    this.activeModal.close();
  }

  withdraw() {
    this.withdrawApplication.emit(this.application);
  }

  getStatus(application: Application) {
    
    if(application.status ==='NotStarted') {
      return '';
    } else if((application.status == 'ProvisionallyFunded' || application.status == 'Rejected' || application.status == 'ApplicationProgress') && application?.hideFundingOutCome === true){
      return 'Application in progress until the 10th of December 2026';
    }else if(application.status ==='ProvisionallyFunded') {
      return 'Funding Eligible for ' + application?.fundingBucket;
    }
    else if(application.status == 'RegistrationReceived'){
      return 'Registration Received for '+ application?.fundingBucket;
    }
    else if(application.status ==='Withdrawn') {
      return 'Cancelled';
    }else if(application.status ==='Filtering' || application.status ==='Validation') {
      return 'Filtering and validation';
    }else if(application.status ==='AwaitingEvaluation') {
      return 'Verification';
    }else if(application.status ==='ApplicationInProgress') {
      return 'Requesting Financial AND/OR Academic data';
    }    
    else if(application.status == 'FundingEligibleForLoan'){
      return 'Funding Eligible Subject to Qualification Check and Document Completion at Institution';
    }
    if(application.status == 'PendingAcceptanceOfBursaryOffer'){
      return 'Pending Acceptance of Bursary Offer';
    }

    return _.startCase(application.status);
  }

  getIndex() {
    let indx = 0;
    if (this.getStatus(this.application) === 'Not Started') {
      indx = 0;
    }  else if (this.getStatus(this.application) === 'Submitted') {
      indx = 0;
    } else if (this.getStatus(this.application) === 'Rejected') {
      indx = 6;
    } else if (this.getStatus(this.application)=== 'Awaiting Evaluation') {
      if (indx < 1) {
        indx = 1;
      }
    }else if (this.getStatus(this.application) === 'Finance Eligibility' || this.getStatus(this.application) === 'Assessing Financial Eligibility') {
      if (indx < 2) {
        indx = 2;
      }
    } else if (this.getStatus(this.application) === 'Awaiting Academic Eligibility Check') {
      if (indx < 3) {
        indx = 3;
      }

    }else if (this.getStatus(this.application) === 'Awaiting Academic Results') {
      if (indx < 4) {
        indx = 4;
      }

    } else if (this.getStatus(this.application) === 'Funding Eligible') {
      if (indx < 5) {
        indx = 5;
      }

    }   else if (this.getStatus(this.application) === 'Awaiting Institution Data') {
      if (indx < 3) {
        indx = 3;
      }
    } else if (this.getStatus(this.application) === 'Agreement Signed') {
      if (indx < 6) {
        indx = 6;
      }
    }
    return indx;
  }

  back() {
  }
  
  searchDisbursementExclusions(){
    
  }

}
